import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LifeBuoy } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';

/**
 * Faixa permanente de uma sessão de SUPORTE: um operador da plataforma a atuar neste ginásio com um acesso explícito e auditado.
 * Diz sempre onde se está e quando termina, e dá a saída. Quem não está numa sessão de suporte nunca a vê.
 */
const SupportBanner = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [now, setNow] = useState(() => Date.now());

  const support = !!user?.support;
  useEffect(() => {
    if (!support) return undefined;
    const timer = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(timer);
  }, [support]);

  if (!support) return null;

  const expires = user.supportExpiresAt ? new Date(user.supportExpiresAt).getTime() : null;
  const minutes = expires ? Math.max(0, Math.ceil((expires - now) / 60000)) : null;

  const finish = async () => {
    // Revoga o token no servidor (jti): terminar o suporte não pode deixar um token válido até aos 30 min. Se falhar (rede), o fim do prazo continua a valer.
    try { await api.post('/auth/logout'); } catch { /* melhor esforço */ }
    logout();               // limpa a sessão do portal (token, user, permissões e caches) — a da plataforma fica
    navigate('/superuser');
  };

  return (
    <div
      role="status"
      data-testid="support-banner"
      style={{
        display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap',
        padding: '0.5rem 1.25rem', background: 'var(--warning-bg)', color: 'var(--warning-text)',
        borderBottom: '1px solid var(--warning)', fontSize: '0.8125rem', fontWeight: 600,
      }}
    >
      <LifeBuoy size={16} aria-hidden="true" />
      <span>
        Sessão de suporte{user.supportInstance ? ` em ${user.supportInstance}` : ''}
        {minutes != null && (minutes > 0 ? ` · termina em ${minutes} min` : ' · expirada')}
        {' '}· não altera utilizadores, perfis nem passwords
      </span>
      <button type="button" className="btn btn-secondary" style={{ marginLeft: 'auto' }} onClick={finish}>
        Terminar suporte
      </button>
    </div>
  );
};

export default SupportBanner;
